enum TeachingWizardStep {
  CreateTeachAndRepeatZoneStep = 0,
  TeachingStep = 1,
  EditZoneStep = 2,
  EditConfigurationStep = 3,
  EndTeachingStep = 4,
}

export default TeachingWizardStep;
